<template>
  <div>

    <div>
      <div class="vuse-content-wrapper mt-4">
        <v-row >
          <v-col cols="12" md="2" class="mt-0">
            <h2 class="ml-3 float-left">
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="xmlReport">
                      <ExcelIcon />
                    </v-btn>
                  </template>
                  <span>Download Table as CSV</span>
                </v-tooltip>
              </span>
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="loadData">
                      <v-icon>sync</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh</span>
                </v-tooltip>
              </span>
             {{$t(page+'.Invoices')}}
            </h2>
          </v-col>
          <v-spacer></v-spacer>
          <v-item-group v-model="status" class="ml-3">
            <v-item class="float-left mr-5" #default="{ active, toggle }">
              <v-switch inset @change="toggle(!active)" 
                        :label="$t(page+'.All')" value="ALL" :input-value="active" hide-details ></v-switch>
            </v-item>
            <v-item class="float-left mr-5" #default="{ active, toggle }">
              <v-switch inset @change="toggle(!active)" 
                        :label="$t(page+'.Unpaid')" value="UNPAID" :input-value="active" hide-details ></v-switch>
            </v-item>
            <v-item class="float-left" #default="{ active, toggle }">
              <v-switch inset @change="toggle(!active)" 
                        :label="$t(page+'.Overdue')" value="OVERDUE" :input-value="active" hide-details ></v-switch>
            </v-item>
          </v-item-group>            
          <v-spacer></v-spacer>
          <v-col class="text-right" cols="12" md="2">
            <v-btn color="black" class="mr-3" dark @click.stop="timeframe_dialog = true" v-if="timeframe">
              <v-icon left dark>
                mdi-calendar
              </v-icon>
              {{formattedTimeframe}}
            </v-btn>
          </v-col> 
        </v-row>
        <!--<v-row v-if="!orders">
          <no-data />  
        </v-row>-->

        <v-row class="mt-0">
          <v-col cols="12" class="mt-2">
            <v-card class="neu-glow pb-4">
              <v-card-title>
                <v-col cols=12 sm="4" lg="3" >
                  <v-btn outlined :loading="editLoading" :disabled="selectedOrders.length!=1" v-on="on" tile color="info" @click="showInvoice()" class="mt-2 ml-2">
                    <v-icon left>
                      fas fa-eye
                    </v-icon>
                    {{$t(page+'.Show Invoice')}}
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    style="max-width:250px"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-div class="mr-4 font-weight-black" v-if="totalAmount">
                  {{$t(page+'.Total Amount') + ': ' + parseFloat(totalAmount).toFixed(2) }}
                </v-div>
              </v-card-title>
              <v-data-table
                  show-select
                  item-key="docId"
                  dense
                  v-model="selectedOrders"
                  fixed-header="true"
                  :headers="i18_headers"
                  :items="orders==null?[]:orders"
                  :items-per-page=9999
                  :height="wIH - 362"
                  :search="search"
                  multi-sort
                  class="elevation-1 mx-4"
                  :loading="loading" 
                  :loading-text="$t(page+'.Loading... Please wait')"
                  :no-data-text="$t(page+'.No data Available')"
                  :no-results-text="$t(page+'.No Record matching search parameters')"
                >
                  <template v-slot:[`item.issueDate`]="{ item }">
                    <v-div>{{new Date(Date.parse(item.issueDate)).toLocaleDateString(user.locale, { year: 'numeric', month: 'long', day: 'numeric'})}}</v-div>
                  </template>

                  <template v-slot:[`item.docAmount`]="{ item }">
                    <v-div>{{parseFloat(item.docAmount).toFixed(2)}}</v-div>
                  </template> 

                  <template v-slot:[`item.URL`]="{ item }">
                    <v-btn class="mx-2" dark small color="primary" @click="showInvoice(item.url)">
                      <v-icon dark>fas fa-file-invoice-dollar</v-icon>
                    </v-btn>
                  </template> 

                  <template v-slot:[`item.dueDate`]="{ item }">
                    <v-div>{{new Date(Date.parse(item.dueDate)).toLocaleDateString(user.locale, { year: 'numeric', month: 'long', day: 'numeric'})}}</v-div>
                  </template>

                  <template v-slot:[`item.paymentDate`]="{ item }">
                    <v-div v-if="item.paymentDate!=null">{{new Date(Date.parse(item.paymentDate)).toLocaleDateString(user.locale, { year: 'numeric', month: 'long', day: 'numeric'})}}</v-div>
                  </template>               

              </v-data-table>
            </v-card>
          </v-col>
        </v-row>        
      </div>
    </div>
    <v-dialog v-model="timeframe_dialog" max-width="500">
        <v-card>
          <v-card-title class="text-h5">
            Select Time Frame
          </v-card-title>
          <v-card-text>
            <v-date-picker class="mt-4" v-model="timeframe" :locale="user.locale" range full-width @change="change_timeframe"></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="primary" @click="timeframe_dialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog eager v-model="showPDF_dialog" fullscreen hide-overlay open-delay="500" scrollable="true" transition="dialog-bottom-transition">
      <v-card heigth="100%">
        <v-toolbar
          dark
          color="primary"
          class="pt-2"
        >
          <v-btn
            icon
            dark
            @click="showPDF_dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>PDF</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="showPDF_dialog = false"
            >
              Close
            </v-btn>
            <v-text-field
              label="Email"
              placeholder="Email"
              outlined
              :value="null"
            ></v-text-field>
            <v-btn
              dark
              small
              color="info"
              @click="showPDF_dialog = false"
            >
              <v-icon>
                fas fa-paper-plane
              </v-icon>
              Email to
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <iframe id="ifrm" :src="showPDF_url" width="100%" height="100%"></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
  .bordered::before{
    border-color:transparent;
    border: 6px solid green!important;
  }
  .bottomborder::before{
    border-color:transparent;
    border-bottom: 8px solid blue!important;
  }
  .wrapped{
    height:60px!important;
    border-style:none!important;
  }
  .v-btn:before{
    background-color: inherit!important;
  }
  .v-btn--active:before{
    opacity:1!important;
  }
  .v-btn__content{
    display:block!important;
    }
  .v-btn-vertical{
    flex-direction: column!important;
  }
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import { availableCountries  } from "@/config/countries";
import DoughnutChart from "@/components/ChartJS/DoughnutChart";

import _ from 'lodash'
export default {
  components: { NoData, SkeletonRevenue, ExcelIcon, availableCountries,DoughnutChart},
  computed : {
    ...mapGetters(["user","settings","orders","shippingServices","shipping_departures","active_status","active_carriers","carriers","status","shipping_options","departures","formattedTimeframe"]),
    active_carrier_value: function () {
      console.log(this.active_carriers);
    },
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
    buildChart()
    {
      this.data={};
      let datasetscount=0;
      console.log('258_payload',this.payload);
      this.orders=this.payload.table;
      this.data.labels = this.payload.labels;
     
      let enabled=this.enabled_SuppliersAccounts==['All Suppliers']?[]:this.enabled_SuppliersAccounts;
      console.log(enabled);
      if (enabled.join()==''||enabled.join()=='All Suppliers')
      {
        enabled=this.user.SuppliersAccounts.split(',')
      }
      if (enabled.length>1 && enabled.includes(''))              
      {
        enabled=enabled.filter(f => f !== '');
      }
      console.log(299,'enabled',enabled);

      this.data.datasets=[];
      enabled.forEach( e =>
        {           
          console.log('e',e);
          if (this.payload[e]!== undefined)
          {
            if (this.payload[e].reduce((a, b) => a + b, 0)>0)
            {
              this.settings.line_empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
              this.settings.line_empty_dataset.data = this.payload[e].map(x => this.convertedAmount(x));
              this.settings.line_empty_dataset.gradientStroke= lc.linecolors[e];
              this.data.datasets.push(JSON.parse(JSON.stringify(this.settings.line_empty_dataset)));
              datasetscount++
            }
          }
        }
      );
     // this.$refs.LineChart.rerender();
      if (datasetscount>1)
      {
          let e='total';
          this.settings.line_empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
          this.settings.line_empty_dataset.data = this.payload[e].map(x => this.convertedAmount(x));
          this.settings.line_empty_dataset.gradientStroke = lc[e];
          this.data.datasets.unshift(JSON.parse(JSON.stringify(this.settings.line_empty_dataset)));
      }      
      return this.data;
    },
  },    
  data() {
    return {
      namespace: "Reports",
      page: "BossInvoices",
      orders: null,
      departures:null,
      form:{},
      payload:{},
      activeCarriers:[],
      activeDepartures:[],
      countries:availableCountries,
      buyer_address_dialog:false,
      loading: true,
      search: '',
      errorid: null,
      timeframe: [],
      timeframe_dialog: false,
      availableShippingServices:null,
      activeeBayAccounts: [],
      enabled_departure:[],
      chart1_options:null,
      chart2_options:null,
      b_carriers:[],
      b_depos:[],
      wIH:window.innerHeight,
      selectedOrders:[],
      showPDF_dialog:false,
      showPDF_url:'',
      data:
      {
        labels: [],
        datasets: [{
            label: 'Shipment Status',
            data: [],
            backgroundColor: [],
            borderWidth: 1
        }]
      },
      data2:
      {
        labels: [],
        datasets: [{
            label: 'Shipment Status',
            data: [],
            backgroundColor: [],
            borderWidth: 1
        }]
      },
      headers: [
          //{ text: '#', align: 'start', value: 'index', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Customer', value: 'username',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Plafond', value: 'plafond',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'IssueDate', value: 'issueDate',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'DocName', value: 'docName',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4' },
          { text: 'DocNumber', value: 'docNumber',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4' },	
          { text: 'Currency', value: 'currency',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4' },
          { text: 'Amount', value: 'docAmount',align: 'end', class : 'text-subtitle-1 font-weight-black primary--text py-4' },
          //{ text: 'Link', value: 'URL',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Due Date', value: 'dueDate',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'MoP', value: 'meansOfPayment',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'PaymentDate', value: 'paymentDate',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'PaymentReference', value: 'paymentId',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'}
      ],
    };
  },
  created(){
    const date=new Date();
    this.timeframe=this.user.datefrom!=undefined?[this.user.datefrom,this.user.dateto]:[new Date(date.setMonth(date.getMonth()-1)).toISOString().split("T")[0],new Date(date.setMonth(date.getMonth()+1)).toISOString().split("T")[0]];
    console.log(this.timeframe);
    console.log(333,this.active_carriers,this.shipping_departures,this.active_status,this.timeframe,this.departures);
    console.log(356,[new Date(date.setMonth(date.getMonth()-1)).toISOString().split("T")[0],date.toISOString().split("T")[0]]);
    console.log(357,this.user.datefrom);
    //this.activeCarriers=this.active_carriers[0];
    //this.activeStatus=this.active_status;
    this.activeStatus=0;
    this.active_status=0;

    //this.activeDepartures[0]=this.shipping_departures[0].departureCode;
    this.loadData('OPEN')
  },
  methods:
  {
    showInvoice()
    {
      console.log(312,this.selectedOrders);
      this.showPDF_url=this.selectedOrders[0].URL;
      this.showPDF_dialog=true;
    },
    setActiveStatus(){
      console.log(287,this.active_status,this.activeStatus)
      this.$store.dispatch("setActiveStatus", this.activeStatus);
      let filter=this.status[this.activeStatus].filter;
      console.log('filter',filter);
      //filter='AWB';
      this.loadData(filter);
    },
    change_timeframe(){
      if (this.timeframe[0]>this.timeframe[1])
      {
        let tmp=this.timeframe[0];
        this.timeframe[0]=this.timeframe[1]
        this.timeframe[1]=tmp;
      }
      this.$store.dispatch("set_timeframe", this.timeframe);  
      this.loadData();
    },
    refreshData(){
      let status=this.status[this.activeStatus].filter
      console.log(550,status,this.activeStatus,this.status);
      this.loadData(status);
    },
    setStatus(newstatus)
    {
      console.log(516,newstatus,this.activeStatus2);

      //this.status
    },
    async xmlReport(){
      let payload={"timeframe":this.timeframe.toString(),"sellers":this.activeeBayAccounts.toString()};
      window.location.href='/ajax/reports/revenue_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(status='OPEN'){
      this.loading=true
      console.log(447,status);
      status=status==''?this.status[this.activeStatus].filter:status;
      console.log(449,status);
      status='AWB';
      this.timeframe=this.timeframe.length==0?[this.user.datefrom,this.user.dateto]:this.timeframe;
      //console.log('438_loadData',status,this.timeframe.toString(),this.activeeBayAccounts.toString(),this.activeCarriers,this.activeDepartures,this.activeStatus,this.status[this.activeStatus].filter);
      let datasetscount=0;
      this.$store.dispatch("setOrders", []);
      try{
          //let lc=[[colors.red.base,colors.red.lighten3],[colors.pink.base,colors.pink.lighten3],[colors.purple.base,colors.purple.lighten3],[colors.indigo.base,colors.indigo.lighten3],[colors.blue.base,colors.blue.lighten3],[colors.cyan.base,colors.cyan.lighten3],[colors.teal.base,colors.teal.lighten3],[colors.green.base,colors.green.lighten3],[colors.lime.base,colors.lime.lighten3],[colors.yellow.base,colors.yellow.lighten3],[colors.amber.base,colors.amber.lighten3],[colors.orange.base,colors.orange.lighten3],[colors.brown.base,colors.brown.lighten3],[colors.red.lighten3,colors.red.darken3],[colors.pink.lighten3,colors.pink.darken3],[colors.purple.lighten3,colors.purple.darken3],[colors.indigo.lighten3,colors.indigo.darken3],[colors.blue.lighten3,colors.blue.darken3],[colors.cyan.lighten3,colors.cyan.darken3],[colors.teal.lighten3,colors.teal.darken3],[colors.green.lighten3,colors.green.darken3],[colors.lime.lighten3,colors.lime.darken3],[colors.yellow.lighten3,colors.yellow.darken3],[colors.amber.lighten3,colors.amber.darken3],[colors.orange.lighten3,colors.orange.darken3],[colors.brown.lighten3,colors.brown.darken3],[colors.grey.lighten3,colors.grey.darken3]];
          const payload={"action":"tracking","timeframe":this.timeframe,"status":status}

          const res = await this.$http.post('/boss/invoices.php', payload );
          console.log(506,res)
          
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              
              let p=res.data.payload;
              //this.$store.dispatch("setOrders", p.orders);
              this.totalAmount=p.orders[0].totalAmount;
              /*
              this.chart=p.chart;
              this.b_depos=p.departures;
              this.b_carriers=p.carriers;
              this.chart1_options=JSON.parse(JSON.stringify(this.settings.doughnut_option));

              this.chart1_options.title.text='by Count';
              this.chart1_options.title.position='left'
              //this.data.labels=null;
              this.data.labels= p.chart.map(o => {return o.title})
              this.data.datasets[0].label='Shipment Status'
              this.data.datasets[0].data=p.chart.map(o => {return o.orderscount})
              this.data.datasets[0].backgroundColor=p.chart.map(o => {return o.chartRGB})

              this.chart2_options=JSON.parse(JSON.stringify(this.settings.doughnut_option));
              this.chart2_options.title.text='by Costs';
              this.chart2_options.title.position='left'
              //this.data2.labels=null;
              this.data2.labels= p.chart2.map(o => {return o.title})
              this.data2.datasets[0].label='Shipment Status'
              this.data2.datasets[0].data=p.chart2.map(o => {return o.orderscount})
              this.data2.datasets[0].backgroundColor=p.chart2.map(o => {return o.chartRGB})

              console.log(624,this.data,this.chart);
              console.log(433,p.orders,this.totalAmount,this.b_carriers);
              /*
              this.$store.dispatch("setDepos", p.departures);
              this.$store.dispatch("setStatus", p.status);
              this.$store.dispatch("setCarriers", p.carriers);
              */
             /*
              if (p.carriers_group)
              {
                this.$store.dispatch("setCarriersGroup", res.data.payload.carriers_group);
              }*/
              //console.log(328,res.data.payload.shipping_services,p.availableShippingServices)
              //this.$store.dispatch("setFixings", res.data.fixings);
              this.orders=p.orders=null?[]:p.orders;
              //this.departures=p.departures;
              console.log(346,res.data.payload.departures,this.departures,p.orders,this.orders)
              //this.availableShippingServices=this.shipping_options;
              //this.loading= false;
            break;

            case '0001':

            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading=false;

          /*
          if (res.data.errorid=='0')
          { 
            this.data.datasets[0].data = p.data0;
            this.data.datasets[1].data = p.data1;
            this.data.labels = p.labels;
            this.orders=p.table;
            this.total=p.total;
            sessionStorage.setItem('jwt', res.data.jwt);
          }
          else
          {
            this.$router.push('/auth/login').catch(() => {});
            //this.$router.go();
          }
          this.loading= false;
          //console.log(res.data);
          */

      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }
      this.loading= false;
    },
    getRandomColor() {
        var letters = '789ABCD'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.round(Math.random() * 6)];
        }
        console.log(color);
        return color;
    },
  },
};
</script>
<!--<style scoped>
.theme--light.v-messages{
  display:none;
}
</style>-->